import { Injectable } from '@angular/core';

import { ApiService } from './api.service';

export interface NavigationAssistantRequest {
  message: string;
  context?: {
    currentUrl?: string;
  };
}

export interface NavigationAssistantResponse {
  url: string | null;
  pageId: string | null;
  description: string;
}

/**
 * Wraps the non-streaming `/api/ai/navigation-assistant` endpoint. Translates
 * a natural-language navigation request into a resolved URL via the navigation
 * sub-agent (entity lookup + page catalog). The caller applies the navigation
 * client-side using the returned URL.
 */
@Injectable({
  providedIn: 'root',
})
export class NavigationAssistantService {
  constructor(private apiService: ApiService) {}

  resolve(payload: NavigationAssistantRequest): Promise<NavigationAssistantResponse> {
    return this.apiService.postPromise('/ai/navigation-assistant', payload);
  }
}
